import React, { useEffect } from "react";
import useNuJobsStore from "../../../store/nujobs.store";
import { Form, Input, Button, Select } from "antd";
import { SearchOutlined, EnvironmentOutlined, AppstoreOutlined } from "@ant-design/icons";
import "./jobListingSearch.scss";
import "../../../styles/global.css";
import { SUPPORTED_JOB_CATEGORY, SUPPORTED_LOCATION } from "../../../helper/categoryconstants";

export default function JobListingsSearch({ resultHandler, loggedIn }) {
  const [form] = Form.useForm();
  const { getOSAllJds, resetCurrentSearch } = useNuJobsStore();

  useEffect(() => {
    resetCurrentSearch();
  }, []);

  const encodeJson = (values) => {
    let encodedJsonValues = {};
    encodedJsonValues.keywords = values.keywords;
    encodedJsonValues.city = values.location;
    encodedJsonValues.category = values.category;
    encodedJsonValues.timestamp = 0;
    encodedJsonValues.postingdate = "All";
    encodedJsonValues.pagenum = 1;
    encodedJsonValues.maxPerPage = 10;
    encodedJsonValues.minexp = null;
    encodedJsonValues.maxexp = null;
    encodedJsonValues.minctc = null;
    encodedJsonValues.maxctc = null;
    encodedJsonValues.noticeperiod = [];
    encodedJsonValues.postingdate = [];
    encodedJsonValues.workmode = null;
    encodedJsonValues.diversity = null;
    encodedJsonValues.role = [];
    encodedJsonValues.roletype = [];
    encodedJsonValues.companytype = null;
    encodedJsonValues.jobfor = null;
    if (loggedIn) {
      const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
      encodedJsonValues.nujuid = userData.nujuid;
      encodedJsonValues.nujoid = userData.nujoid;
      encodedJsonValues.loggedin = true;
      encodedJsonValues.pendingsync = JSON.parse(
        localStorage.getItem("NuJobsPendingSync") || "[]"
      );
    }
    return encodedJsonValues;
  };

  const handleFormSubmit = (values) => {
    const jasonValues = encodeJson(values);
    getOSAllJds(jasonValues, resultHandler);
  };

  return (
    <div className="jobListingSearch-wrapper">
      <div className="jobListingSearch-title">
        <div className="jobListing-punchLine">
          Discover Jobs Across <span className="text-blue">Multiple Companies</span>
        </div>
        <div className="jobListingSearch-search-wrapper">
          <Form
            className="jobListingSearch-form"
            name="jobListing-search"
            autoComplete="off"
            onFinish={handleFormSubmit}
            form={form}
          >
            <div className="jobListing-search">
              <Form.Item name="keywords">
                <Input
                  className="jobListing-search-item"
                  type="text"
                  placeholder="Job title, skill or keyword"
                  prefix={<SearchOutlined className="jobListing-field-icon" />}
                />
              </Form.Item>
              <div className="jobListing-select-with-icon">
                <EnvironmentOutlined className="jobListing-field-icon" />
                <Form.Item name="location">
                  <Select
                    mode="multiple"
                    maxTagCount={2}
                    size="large"
                    placeholder="Any Location"
                    allowClear
                    className="jobListing-search-item"
                    options={SUPPORTED_LOCATION}
                  />
                </Form.Item>
              </div>
              <div className="jobListing-select-with-icon">
                <AppstoreOutlined className="jobListing-field-icon" />
                <Form.Item
                  name="category"
                  rules={[{ required: true, message: "Kindly Select at least one Category" }]}
                >
                  <Select
                    mode="multiple"
                    allowClear
                    maxTagCount={2}
                    size="large"
                    className="jobListing-search-item"
                    placeholder="Any Category"
                    options={SUPPORTED_JOB_CATEGORY}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="jobListing-search-button-wrapper">
              <Button className="jobListing-search-button" htmlType="submit">
                Search Jobs
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}
